import React from 'react';
import Helmet from 'react-helmet';
import Moment from 'moment';
import _ from 'lodash';
import Tippy from '../components/ReactTippy';
import Auth from '../components/Auth';
import {
  USER_ROLES,
  HEADER_CONSTANTS,
  API_FLAG,
  REQUEST_PARAMS,
} from '../utilities/constants';

import { messageUtility } from '../utilities/messageUtility';
import SessionStorageService from '../services/utilities/SessionStorageService';
import FieldService from '../services/Fields';
import FieldItemService from '../services/FieldItems';

import WorksInfinityScrollLoad from '../components/WorksInfinityScrollLoad';
import WorkScheduleAllSearchForm from '../components/WorkScheduleAllSearchForm';
import '../styles/componentStyle/work-schedule-all.scss';
import { ConferencePageHeader } from '../components/PageHeader';

const pageTitle = `他社予定確認`;
class WorkScheduleAll extends React.Component {
  state = {
    customColumnNames: {
      item3: '他職への注意事項',
    },
    isLoading: true,
    works: [],
    totalCount: 0,
    searchParams: {}, // 検索条件
    tempSearchParams: {}, // 検索条件(保存用)
    displayFlg: {
      field_item_list1_display_flag: '',
      field_item_list2_display_flag: '',
      field_item_list3_display_flag: '',
      field_item_list4_display_flag: '',
    },
    options: {}, // プルダウン初期表示用データ
    reload: false, // 再読み込みフラグ
  };

  async componentDidMount() {
    Promise.all([this.searchConditionInit(), this.loadWorks()])
      .then(response => {
        const loadWorksResult = response[1];
        if (loadWorksResult) {
          this.setState({
            works: loadWorksResult.works,
            totalCount: loadWorksResult.totalCount,
          });
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.searchParams !== this.state.searchParams) {
      this.setState(
        {
          works: [],
          workTotal: 0,
          isLoading: true,
        },
        async () => {
          const result = await this.loadWorks();
          if (result) {
            this.setState({
              isLoading: false,
              works: [...this.state.works, ...result.works],
              totalCount: result.totalCount,
            });
          }
        }
      );
    } else if (prevState.reload !== this.state.reload) {
      if (this.state.reload) {
        this.reloadWorkData();
      }
    }
  }
  // 検索条件初期化
  searchConditionInit = async () => {
    const fieldItemRes = await FieldService.fieldItem(
      SessionStorageService.getFieldId()
    );
    if (!fieldItemRes || fieldItemRes.result === false) {
      return;
    }
    const displayFlg = this.state.displayFlg;
    const item_list_ids = [1, 2, 3, 4];
    const field_item = fieldItemRes.data.entities.field_item;
    _.each(displayFlg, (value, key) => {
      displayFlg[key] = field_item[key];
    });

    _.map(item_list_ids, (itemListId, key) => {
      if (field_item[`field_item_list${itemListId}_display_flag`] === 0) {
        item_list_ids.splice(key, 1);
      }
    });

    if (item_list_ids.length > 0) {
      const params = {
        item_list_ids,
        is_limit: 1,
        offset: 0,
        limit: REQUEST_PARAMS.parentLimit,
        // 有効のものだけ表示
        display_flag: 1,
      };
      // 現場作業エリア情報取得API
      const optionsRes = await FieldItemService.list(
        SessionStorageService.getFieldId(),
        params,
        true // 暗転防止
      );
      if (!optionsRes || optionsRes.result === false) {
        return;
      }

      this.setState({
        options: optionsRes.data.entities,
        loaded: true,
      });
    }
  };

  loadWorks = async () => {
    const offset = this.state.works.length;
    const params = {
      limit: REQUEST_PARAMS.parentLimit,
      ...this.mergeDateParameter(this.state.searchParams),
      order: 'display_start_date_desc',
      offset,
    };

    const response = await FieldService.allPartnerCompanyList(
      SessionStorageService.getFieldId(),
      params,
      true // 暗転防止
    );
    if (response.result) {
      return {
        works: response.data.entities.works,
        totalCount: response.data.total,
      };
    } else {
      return {
        works: [],
        totalCount: 0,
      };
    }
  };

  addLoadWorkData = async notify => {
    // 追加読込の場合はisLoadingを見て連続で呼ばれないようにする
    if (this.state.isLoading) {
      return;
    }
    this.setState({ isLoading: true });
    const result = await this.loadWorks(notify);
    if (result) {
      this.setState({
        isLoading: false,
        works: [...this.state.works, ...result.works],
        totalCount: result.totalCount,
      });
    }
  };

  // 日付系パラメータを検索パラメータに含める
  mergeDateParameter = sourceParams => {
    return {
      ...sourceParams,
      work_hour_zone: SessionStorageService.getWorkHourZone(),
      date_from: SessionStorageService.getFromDate(),
      date_to: SessionStorageService.getToDate(),
    };
  };

  // 検索条件の変更ハンドリング
  setSearchParam = () => {
    this.setState({ searchParams: _.cloneDeep(this.state.tempSearchParams) });
  };

  // 検索条件のリセット
  resetSearchParam = () => {
    this.setState({
      options: {},
      searchParams: {},
      tempSearchParams: {},
    });
  };

  // 検索条件(保存用)の変更ハンドリング
  setTempSearchParam = (name, value) => {
    this.setState(prevState => ({
      tempSearchParams: {
        ...prevState.tempSearchParams,
        [name]: value,
      },
    }));
  };

  render() {
    const loadedWorkTotal = _.size(this.state.works);
    return (
      <div id='main' className='main WorkScheduleAll'>
        <Auth approvedRoles={[USER_ROLES.partner, USER_ROLES.foreman]}>
          <Helmet>
            <title>
              {HEADER_CONSTANTS.conference} - {pageTitle}
            </title>
          </Helmet>
          <ConferencePageHeader title={pageTitle} />
          <div className='searchForm' />

          <div id='scrolll-parent' className='main__body'>
            <div className='schedulelist'>
              <WorkScheduleAllSearchForm
                value={this.state.displayFlg}
                onSetSearchParam={this.setSearchParam}
                onResetSearchParam={this.resetSearchParam}
                workTotal={this.state.totalCount}
                fieldId={SessionStorageService.getFieldId()}
                options={this.state.options}
                loaded={this.state.loaded}
                isLoading={this.state.isLoading}
                tempSearchParams={this.state.tempSearchParams}
                onSetTempSearchParam={this.setTempSearchParam}
              />
              <div className='schedulelist__content'>
                <div
                  className='schedulelist__list'
                  id='scroll-parent-non-private-work'
                >
                  <ScrollList
                    customColumnNamesItem3={this.state.customColumnNames.item3}
                    listItems={this.state.works}
                  />

                  <WorksInfinityScrollLoad
                    targetId={'scroll-parent-non-private-work'}
                    callback={this.addLoadWorkData}
                    loaded={this.state.totalCount <= loadedWorkTotal}
                    total={this.state.works}
                    isLoading={this.state.isLoading}
                    ignoreIndicator={true}
                  />
                  {this.state.isLoading ? null : this.state.totalCount !==
                    0 ? null : (
                    <div className='table-has-no-data'>
                      <div className='table-has-no-data__message'>
                        {messageUtility.getMessage('I-000-005')}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Auth>
      </div>
    );
  }
}

const ScrollList = ({ customColumnNamesItem3, listItems }) => {
  return (
    <React.Fragment>
      <table className='data-table'>
        <thead className='data-table__header'>
          <tr className=''>
            <th className='data-table__head'>日付</th>
            <th className='data-table__head'>協力会社</th>
            <th className='data-table__head'>職種</th>
            <th className='data-table__head'>職長名</th>
            <th className='data-table__head'>作業場所</th>
            <th className='data-table__head'>作業内容</th>
            <th className='data-table__head'>{customColumnNamesItem3}</th>
            <th className='data-table__head'>早残</th>
            <th className='data-table__head'>人工</th>
          </tr>
        </thead>
        <tbody>
          {listItems.map((data, index) => {
            // 職長名
            const foreman_user_name = `${
              data.foreman_user_name_sei ? data.foreman_user_name_sei : ''
            } ${data.foreman_user_name_mei ? data.foreman_user_name_mei : ''} `;

            const abortedClassName = data.state_handling_flag
              ? 'data-table__item--aborted'
              : '';

            return (
              <React.Fragment key={index}>
                <tr
                  className={`data-table__item table__item--schedule-table ${abortedClassName}`}
                >
                  <td className='data-table__cell data-table__cell--minimum'>
                    <div className='data-table__content'>
                      {Moment(data.work_date).format('MM/DD')}
                    </div>
                  </td>
                  {/* 協力会社 */}
                  <td className='data-table__cell data-table__cell--lg'>
                    <Tippy
                      duration={10}
                      distance={24}
                      arrowType='sharp'
                      delay={[500, 0]}
                      placement='bottom'
                      followCursor={true}
                      html={
                        <div className='data-table__tooltip'>
                          {data.company_name}
                        </div>
                      }
                    >
                      <div className='data-table__content sys-tooltip'>
                        {data.company_name === data.company_name_1 ? (
                          <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                            {data.company_name}
                          </span>
                        ) : (
                          <React.Fragment>
                            <span className='data-table__text-wrap data-table__text-wrap--line-clamp data-table__text-wrap--overflow'>
                              {data.company_name_1}
                            </span>
                            <span
                              className='data-table__text-wrap
                          data-table__text-wrap--line-clamp
                          data-table__text-wrap--overflow'
                            >
                              ({data.company_name})
                            </span>
                          </React.Fragment>
                        )}
                      </div>
                    </Tippy>
                  </td>

                  {/* 職種 */}
                  <td className='data-table__cell data-table__cell--md'>
                    <Tippy
                      duration={10}
                      distance={24}
                      arrowType='sharp'
                      delay={[500, 0]}
                      placement='bottom'
                      followCursor={true}
                      html={
                        <div className='data-table__tooltip'>
                          {data.job_name}
                        </div>
                      }
                    >
                      <div className='data-table__content sys-tooltip'>
                        <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                          {data.job_name}
                        </span>
                      </div>
                    </Tippy>
                  </td>
                  {/* 職長名 */}
                  <td className='data-table__cell data-table__cell--md'>
                    <Tippy
                      duration={10}
                      distance={24}
                      arrowType='sharp'
                      delay={[500, 0]}
                      placement='bottom'
                      followCursor={true}
                      html={
                        <div className='data-table__tooltip'>
                          {foreman_user_name}
                        </div>
                      }
                    >
                      <div className='data-table__content sys-tooltip'>
                        <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                          {foreman_user_name}
                        </span>
                      </div>
                    </Tippy>
                  </td>
                  {/* 作業場所 */}
                  <td className='data-table__cell data-table__cell--md'>
                    <Tippy
                      duration={10}
                      distance={24}
                      arrowType='sharp'
                      delay={[500, 0]}
                      placement='bottom'
                      followCursor={true}
                      html={
                        <div className='data-table__tooltip'>{data.place}</div>
                      }
                    >
                      <div className='data-table__content sys-tooltip'>
                        <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                          {data.place}
                        </span>
                      </div>
                    </Tippy>
                  </td>
                  <td className='data-table__cell data-table__cell--md'>
                    <Tippy
                      duration={10}
                      distance={24}
                      arrowType='sharp'
                      delay={[500, 0]}
                      placement='bottom'
                      followCursor={true}
                      html={
                        <div className='data-table__tooltip'>
                          {data.contents}
                        </div>
                      }
                    >
                      <div className='data-table__content sys-tooltip'>
                        <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                          {data.contents}
                        </span>
                      </div>
                    </Tippy>
                  </td>

                  {/* 他職への注意事項 */}
                  <td className='data-table__cell data-table__cell--md'>
                    <Tippy
                      duration={10}
                      distance={24}
                      arrowType='sharp'
                      delay={[500, 0]}
                      placement='bottom'
                      followCursor={true}
                      html={
                        <div className='data-table__tooltip'>
                          {data.option3}
                        </div>
                      }
                    >
                      <div className='data-table__content sys-tooltip'>
                        <span className='data-table__text-wrap data-table__text-wrap--overflow'>
                          {data.option3}
                        </span>
                      </div>
                    </Tippy>
                  </td>
                  {/* 早残  早出 or 残業 */}
                  <td
                    className='data-table__cell'
                    style={{ paddingRight: '10px' }}
                  >
                    <div
                      className='data-table__content'
                      style={{ maxWidth: '50px' }}
                    >
                      {data.is_early_time !== API_FLAG.On ? null : (
                        <div className='box-info_noline' key='hayade'>
                          早出
                        </div>
                      )}
                      {data.is_over_time !== API_FLAG.On ? null : (
                        <div className='box-info_noline' key='zangyo'>
                          残業
                        </div>
                      )}
                    </div>
                  </td>
                  <td className='data-table__cell' data-unlink>
                    <div className='data-table__content sys-modal-open-jinkou-input'>
                      <div className='sys-modal-open-jinkou-input__item'>
                        <div className='box-info_noline' key='hayade'>
                          人工
                        </div>
                        <span>{data.man_hours}</span>
                      </div>
                    </div>
                  </td>
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </React.Fragment>
  );
};

export { WorkScheduleAll };



// WEBPACK FOOTER //
// ./src/pages/WorkScheduleAll.jsx